import React from "react";
import { Box, Typography } from "@mui/material";
import { UpcomingTrips } from "./Trips/UpcomingTrips";
import { PastTrips } from "./Trips/PastTrips";

export const Banner = () => {
    return (
        <Box         
            maxWidth="xl"
            sx={{ 

            }}
            className="mt-10 banner md:pl-32"
        >
            <Box maxWidth="xl">
                <Typography
                    variant="h5" 
                    className="trips md:text-2xl sm:text-sm trp"
                    sx={{
                        marginTop: "-3%",
                        marginBottom: "3%",
                        fontWeight: "500"
                    }}
                    gutterBottom  
                >
                    Trips
                </Typography>                
                
            </Box>
            <UpcomingTrips />
            <PastTrips />
        </Box>
    );
};
